define('org/forgerock/openam/ui/common/services/ServerService',["exports", "i18next", "lodash", "store/actions/creators", "org/forgerock/commons/ui/common/main/AbstractDelegate", "org/forgerock/commons/ui/common/util/Constants", "./fetchUrl", "store/index", "org/forgerock/commons/ui/common/util/URIUtils"], function (exports, _i18next, _lodash, _creators, _AbstractDelegate, _Constants, _fetchUrl, _index, _URIUtils) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.getVersion = getVersion;
    exports.getConfiguration = getConfiguration;

    var _lodash2 = _interopRequireDefault(_lodash);

    var _AbstractDelegate2 = _interopRequireDefault(_AbstractDelegate);

    var _Constants2 = _interopRequireDefault(_Constants);

    var _fetchUrl2 = _interopRequireDefault(_fetchUrl);

    var _index2 = _interopRequireDefault(_index);

    var _URIUtils2 = _interopRequireDefault(_URIUtils);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /*
     * Copyright 2015-2017 ForgeRock AS. All Rights Reserved
     *
     * Use of this code requires a commercial software license with ForgeRock AS.
     * or with one of its affiliates. All use shall be exclusively subject
     * to such license between the licensee and ForgeRock AS.
     */

    /**
     * @module org/forgerock/openam/ui/common/services/ServerService
     */
    var obj = new _AbstractDelegate2.default(_Constants2.default.host + "/" + _Constants2.default.context + "/json");

    function getRealmUrlParameter() {
        return _URIUtils2.default.parseQueryString(_URIUtils2.default.getCurrentQueryString()).realm;
    }

    function getUrl(path) {
        var realmParameter = getRealmUrlParameter();
        return (0, _fetchUrl2.default)(path, { realm: realmParameter ? realmParameter : false });
    }

    function getVersion() {
        return obj.serviceCall({
            headers: { "Accept-API-Version": "protocol=1.0,resource=1.0" },
            url: getUrl("/serverinfo/version")
        }).then(function (data) {
            return "OpenAM " + data.version + " " + (0, _i18next.t)("common.form.build") + " " + data.revision + " (" + data.date + ")";
        });
    }

    function getConfiguration(callParams) {
        return obj.serviceCall(_lodash2.default.extend({
            headers: { "Accept-API-Version": "protocol=1.0,resource=1.1" },
            url: getUrl("/serverinfo/*")
        }, callParams)).then(function (response) {
            _index2.default.dispatch((0, _creators.serverAddRealm)(response.realm));

            return response;
        }, function (reason) {
            var realmUrlParameter = getRealmUrlParameter();
            if (realmUrlParameter) {
                _index2.default.dispatch((0, _creators.serverAddRealm)(realmUrlParameter));
            }

            return reason;
        });
    }
});

